import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ReleasesSection } from 'libs/portal/src/models/ReleasesSection';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Routes } from '@huge-monorepo/portal/config';
import { Endpoints } from '@huge-monorepo/portal/config';
import { GenericService } from '@huge-monorepo/portal/services';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  constructor(
    private auth: UserRightsService,
    private routes: Routes,
    private navigationService: NavigationService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private endpoints: Endpoints,
    private gs: GenericService,
  ) {}

  MIKROTIK = 'mikrotik';
  CDR = 'cdr';
  KEEPALIVE = 'keepalive';
  RELAY = 'relay';
  SYSTEMADMIN = 'systemadmin';
  USERMANAGEMENT = 'usermanagement';
  REPORTS = 'reports';
  RELEASES = 'releases';
  TELTONIKA = 'teltonika'
  CONTRACTORS = 'contractors';

  hasKeepAliveAccess = false;
  hasCDRAccess = false;
  hasMikrotikAccess = false;
  hasRelayAccess = false;
  hasReportsAccess = false;
  hasUserManAccess = false;
  hasSysAdminAccess = false;
  AccessObject: UserAccessRole = this.auth.GetUserAccessRoles();
  seenReleaseNotes = false;
  hasTeltonikaAccess = false;
  hasContractorsAccess = false;

  private navRoutes: NavRoute[] = [];

  releasesHtml: ReleasesSection = {
    header: '',
    body: '',
  };

  ngOnInit(): void {
    this.AccessObject = this.auth.GetUserAccessRoles();

    if (this.AccessObject) {
      this.navRoutes.push(
        new NavRoute(
          'Data Usage',
          'Monitor and evaluate data usage of devices',
          this.CDR,
          '/assets/img/barAndLineChart.png',
          this.auth.HasCDRAccess() && this.AccessObject.HasCDRAccess(),
        ),
      );
      this.navRoutes.push(
        new NavRoute(
          'Keep Alive',
          'Ensure that your devices are online',
          this.KEEPALIVE,
          '/assets/img/mapLocation.png',
          this.auth.HasKeepAliveAccess() && this.AccessObject.HasKeepAliveAccess(),
        ),
      );
      this.navRoutes.push(
        new NavRoute(
          'Transaction Monitoring',
          'View transactions and download reports',
          this.RELAY,
          '/assets/img/calendar.png',
          this.auth.HasRelayAccess() && this.AccessObject.HasRelayAccess(),
        ),
      );
      this.navRoutes.push(
        new NavRoute(
          'Teltonika',
          'Monitor and manage your teltonika devices',
          this.TELTONIKA,
          '../../../../../assets/icon/teltonika.png',
          this.auth.HasTeltonikaAccess() && this.AccessObject.HasTeltonikaAccess(),
        ),
      );
      this.navRoutes.push(
        new NavRoute(
          'Router Management',
          'Configure and manage your mikrotik devices',
          this.MIKROTIK,
          '/assets/img/routerAndCable.png',
          this.auth.HasMikrotikAccess() && this.AccessObject.HasMikrotikAccess(),
        ),
      );
      this.navRoutes.push(new NavRoute('Reports', 'View available reports', this.REPORTS, '../../../../../assets/img/reports.png', this.AccessObject.IsReporting()));
      this.navRoutes.push(
        new NavRoute(
          'System Administration',
          'Manage system settings',
          this.SYSTEMADMIN,
          '/assets/img/systemAdministration.png',
          ((this.AccessObject.IsSuperUser() && (this.auth.HasCDRAccess() || this.auth.HasKeepAliveAccess())) ||
            (this.auth.HasKeepAliveAccess() && this.AccessObject.IsKeepAliveAdmin()) ||
            (this.auth.HasCDRAccess() && this.AccessObject.IsCDRAdmin())) && this.auth.GetUserPortalReadWrite().PortalWriteAccess,
        ),
      );
      this.navRoutes.push(
        new NavRoute('User Management', 'Manage user accounts and roles', this.USERMANAGEMENT, '../../../../../assets/img/userManagement.png', this.AccessObject.IsSuperUser()),
      );
      this.navRoutes.push(
        new NavRoute(
          'Contractors',
          'View contractors and their jobs',
          this.CONTRACTORS,
          '/assets/Tile-Icons/contractors.png',
          this.auth.HasContractorsAccess() && this.AccessObject.HasContractorsAccess()
        ),
      );
    }

    this.http.get('assets/releases/releases.html', { responseType: 'text' }).subscribe((data) => {
      const pageSplit = data.split('SPLITPAGE');
      const splitPage = pageSplit[0].split('SPLITHEADER');
      this.releasesHtml = {
        header: this.sanitizer.bypassSecurityTrustHtml(splitPage[0]),
        body: this.sanitizer.bypassSecurityTrustHtml(splitPage[1]),
      };
      const version = this.endpoints.APP_VERSION;
      const seenVersion = localStorage.getItem('releaseNoteVersion');
      if (seenVersion) {
        this.seenReleaseNotes = this.splitVersion(version) == this.splitVersion(seenVersion);
      }
    });
  }

  private splitVersion(version: string): string {
    try {
      let splitVersion = version.split('.');
      splitVersion = [splitVersion[0], splitVersion[1], splitVersion[2]];
      return splitVersion.join('.');
    } catch (e: any) {
      return version;
    }
  }

  GoToPage(pageName: string): void {
    switch (pageName) {
      case this.MIKROTIK:
        this.changeRoute(this.routes.MikrotikDashboard);
        break;
      case this.CDR:
        this.changeRoute(this.routes.CDRDashboard);
        break;
      case this.KEEPALIVE:
        this.changeRoute(this.routes.KeepAliveDashboard);
        break;
      case this.RELAY:
        this.changeRoute(this.routes.RelayDashboard);
        break;
      case this.TELTONIKA:
        this.changeRoute(this.routes.TeltonikaDashboard);
        break;
      case this.CONTRACTORS:
        this.changeRoute(this.routes.Contractors);
        break;
      case this.REPORTS:
        this.changeRoute(this.routes.Reports);
        break;
      case this.SYSTEMADMIN:
        this.changeRoute(this.routes.SystemAdmin);
        break;
      case this.USERMANAGEMENT:
        this.changeRoute(this.routes.UserManagement);
        break;
      case this.RELEASES:
        this.changeRoute(this.routes.Releases);
        break;
      default:
        console.warn('Uncatered for subsystem chosen. Please contact an administrator for more info');
    }
  }

  getNavRoutes(): NavRoute[] {
    return this.navRoutes.filter((route) => route.hasAccess);
  }

  changeRoute(url: string): void {
    this.navigationService.Navigate(url);
    this.navigationService.updateNavMenuItems();
  }

  acknowledgeReleaseNotes(event: any) {
    event.stopPropagation();
    localStorage.setItem('releaseNoteVersion', this.endpoints.APP_VERSION);
    this.seenReleaseNotes = true;
  }
}

class NavRoute {
  title: string;
  description: string;
  route: string;
  imgSrc: string;
  hasAccess: boolean;

  constructor(title: string, description: string, route: string, imgSrc: string, hasAccess?: boolean) {
    this.title = title;
    this.description = description;
    this.route = route;
    this.imgSrc = imgSrc;
    this.hasAccess = hasAccess ?? false;
  }
}
